import { FC } from 'react';
import { MICROCOPY } from 'src/data/microcopy/microcopyDictionary';
import { BasicModal } from 'src/general/components/BasicModal/BasicModal';
import { Button } from 'src/general/components/Button/Button';
import { getMicrocopyBulk } from 'src/stores/microcopyStore';

export interface VisaIssuesFormProps {
  isOpen: boolean;
  backToHome: () => void;
}

export const VisaIssuesForm: FC<VisaIssuesFormProps> = ({ isOpen, backToHome }) => {
  const { title, content, buttonLabel } = getMicrocopyBulk({
    title: [MICROCOPY.CHECKOUT_FINANCE_QUOTE_MODAL_VISA_ISSUES_TITLE],
    content: [MICROCOPY.CHECKOUT_FINANCE_QUOTE_MODAL_VISA_ISSUES_CONTENT],
    buttonLabel: [MICROCOPY.CHECKOUT_FINANCE_QUOTE_MODAL_VISA_ISSUES_BUTTON_LABEL],
  });

  return (
    <BasicModal
      id="visa-issues-modal"
      title={title}
      className="md:min-w-xl"
      isOpen={isOpen}
      onClose={backToHome}
      footer={<Button onClick={backToHome}>{buttonLabel}</Button>}
    >
      {content}
    </BasicModal>
  );
};
